//ラジオボタンアイテム
export interface SelectItem {
  label: string; //ラベル
  value: number; //値
}

//セレクトエリアアイテム
export interface PulldownItem {
  text: string; //ラベル
  value: number; //値
}

//メニューアイテム
export interface MenuItem {
  id: number;
  icon: string;
  url: string;
  name: string;
  classes?: string[];
}

//検索条件
export interface SearchCondition {
  isDone: boolean; //未確定の利用者だけを表示
  insuranceNo: string; //保険者番号
  insuranceName: string; //保険者名
  userCode: string; //利用者ID
  userKana: string; //利用者ふりがな
  userInsNo: string; //被保険者番号
}

//テーブルアイテム
export interface TableItem {
  sysId: number;
  id: string;
  name: string;
  office_name: string;
  medical_insurance: string;
  care_insurance: string;
  indicate: string;
  public_money: string;
  sex: string;
  birthday: string;
  address: string;
}

//テーブルセレクトアイテム
export interface ObjectId {
  id: number;
  is_printed: string;
  is_exec: string;
  patient_id: number;
  ibow_id: string;
  name: string;
  updated_at: string;
  yearmonth: string;
}

//テーブルヘッダーアイテム
export interface HeaderItem {
  value: string;
  text: string;
  description?: string;
  filter?: (val: object) => boolean;
  filterType?: number;
}

//テーブルヘッダーアイテム（幅付き）
export interface HeaderWidthItem extends HeaderItem {
  width: string;
}

//日本時間文字列変換(+9hour)
export function dateJp(date: Date): string {
  date.setTime(date.getTime() + 1000 * 60 * 60 * 9);
  return date.toISOString().substr(0, 10);
}

//基準月取得(10日までは前月)
export function getDefaultMonth() {
  const date = new Date();
  const day = date.getDate();
  let month = date.getMonth();
  let year = date.getFullYear();
  if (day < 11) {
    month -= 1;
    if (month == -1) {
      month = 11;
      year -= 1;
    }
  }
  return year + "-" + ("00" + (month + 1)).slice(-2);
}

//内税取得
export function getInnerTax(totalMoney: number, taxRate: number): number {
  return Math.floor((Number(totalMoney) * taxRate) / (100 + taxRate));
}

//ローカルストレージからboolean取得
export function getStorageBoolean(key: string, defaultValue: boolean): boolean {
  const value = localStorage.getItem(key);
  if (value == "false") {
    return false;
  } else if (value == "true") {
    return true;
  } else {
    return defaultValue;
  }
}

//ローカルストレージからnumber取得
export function getStorageNumber(key: string): number {
  const value = localStorage.getItem(key);
  if (value != undefined) {
    return Number(value);
  }
  return 0;
}

//全角カナを半角カナに変換
export function zenkana2Hankana(str: string): string {
  const zen = [
    "ア",
    "イ",
    "ウ",
    "エ",
    "オ",
    "カ",
    "キ",
    "ク",
    "ケ",
    "コ",
    "サ",
    "シ",
    "ス",
    "セ",
    "ソ",
    "タ",
    "チ",
    "ツ",
    "テ",
    "ト",
    "ナ",
    "ニ",
    "ヌ",
    "ネ",
    "ノ",
    "ハ",
    "ヒ",
    "フ",
    "ヘ",
    "ホ",
    "マ",
    "ミ",
    "ム",
    "メ",
    "モ",
    "ヤ",
    "ヰ",
    "ユ",
    "ヱ",
    "ヨ",
    "ラ",
    "リ",
    "ル",
    "レ",
    "ロ",
    "ワ",
    "ヲ",
    "ン",
    "ガ",
    "ギ",
    "グ",
    "ゲ",
    "ゴ",
    "ザ",
    "ジ",
    "ズ",
    "ゼ",
    "ゾ",
    "ダ",
    "ヂ",
    "ヅ",
    "デ",
    "ド",
    "バ",
    "ビ",
    "ブ",
    "ベ",
    "ボ",
    "パ",
    "ピ",
    "プ",
    "ペ",
    "ポ",
    "ァ",
    "ィ",
    "ゥ",
    "ェ",
    "ォ",
    "ャ",
    "ュ",
    "ョ",
    "ッ",
    "゛",
    "°",
    "、",
    "。",
    "「",
    "」",
    "ー",
    "・"
  ];

  const han = [
    "ｱ",
    "ｲ",
    "ｳ",
    "ｴ",
    "ｵ",
    "ｶ",
    "ｷ",
    "ｸ",
    "ｹ",
    "ｺ",
    "ｻ",
    "ｼ",
    "ｽ",
    "ｾ",
    "ｿ",
    "ﾀ",
    "ﾁ",
    "ﾂ",
    "ﾃ",
    "ﾄ",
    "ﾅ",
    "ﾆ",
    "ﾇ",
    "ﾈ",
    "ﾉ",
    "ﾊ",
    "ﾋ",
    "ﾌ",
    "ﾍ",
    "ﾎ",
    "ﾏ",
    "ﾐ",
    "ﾑ",
    "ﾒ",
    "ﾓ",
    "ﾔ",
    "ｲ",
    "ﾕ",
    "ｴ",
    "ﾖ",
    "ﾗ",
    "ﾘ",
    "ﾙ",
    "ﾚ",
    "ﾛ",
    "ﾜ",
    "ｦ",
    "ﾝ",
    "ｶﾞ",
    "ｷﾞ",
    "ｸﾞ",
    "ｹﾞ",
    "ｺﾞ",
    "ｻﾞ",
    "ｼﾞ",
    "ｽﾞ",
    "ｾﾞ",
    "ｿﾞ",
    "ﾀﾞ",
    "ﾁﾞ",
    "ﾂﾞ",
    "ﾃﾞ",
    "ﾄﾞ",
    "ﾊﾞ",
    "ﾋﾞ",
    "ﾌﾞ",
    "ﾍﾞ",
    "ﾎﾞ",
    "ﾊﾟ",
    "ﾋﾟ",
    "ﾌﾟ",
    "ﾍﾟ",
    "ﾎﾟ",
    "ｧ",
    "ｨ",
    "ｩ",
    "ｪ",
    "ｫ",
    "ｬ",
    "ｭ",
    "ｮ",
    "ｯ",
    "ﾞ",
    "ﾟ",
    "､",
    "｡",
    "｢",
    "｣",
    "ｰ",
    "･"
  ];

  let ato = "";

  for (let i = 0; i < str.length; i++) {
    let maechar = str.charAt(i);
    const zenindex = zen.indexOf(maechar);
    if (zenindex >= 0) {
      maechar = han[zenindex];
    }
    ato += maechar;
  }

  return ato;
}

//半角カナ小文字を大文字に変換
export function hankana2Upper(str: string): string {

  const low = [
    "ｧ",
    "ｨ",
    "ｩ",
    "ｪ",
    "ｫ",
    "ｬ",
    "ｭ",
    "ｮ",
    "ｯ"
  ];

  const upper = [
    "ｱ",
    "ｲ",
    "ｳ",
    "ｴ",
    "ｵ",
    "ﾔ",
    "ﾕ",
    "ﾖ",
    "ﾂ"
  ];

  let ato = "";

  for (let i = 0; i < str.length; i++) {
    let maechar = str.charAt(i);
    const lowindex = low.indexOf(maechar);
    if (lowindex >= 0) {
      maechar = upper[lowindex];
    }
    ato += maechar;
  }

  return ato;
}

//平仮名をカタカナに変換
export function hiraToKana(str: string): string {
  return str.replace(/[\u3041-\u3096]/g, match => {
    const chr = match.charCodeAt(0) + 0x60;
    return String.fromCharCode(chr);
  });
}

//ひらがな、かたかなを半角カナに変換
export function moji2Hankana(str: string): string {
  const zenkana = hiraToKana(str)
  return zenkana2Hankana(zenkana)
}

//英数字を半角に変換
export function moji2HanAlphaNum(str: string): string {
  // 半角変換
  const halfVal = str.replace(/[！-～]/g,
    function (tmpStr) {
      // 文字コードをシフト
      return String.fromCharCode(tmpStr.charCodeAt(0) - 0xFEE0);
    }
  );

  // 文字コードシフトで対応できない文字の変換
  return halfVal.replace(/”/g, "\"")
    .replace(/’/g, "'")
    .replace(/‘/g, "`")
    .replace(/￥/g, "\\")
    .replace(/〜/g, "~")
    .replace(/ー/g, "-");
}

//来月を取得
export function nextMonth(): string {
  const today = new Date();
  let month = today.getMonth();
  let year = today.getFullYear();
  const date = today.getDate();
  if (date < 11) {
    month -= 1;
  }
  const targetMonth = month + 1;
  year = Math.floor(targetMonth / 12) + year;
  month = targetMonth % 12;
  const newDate = new Date(year, month, 2);
  return newDate.toISOString().substr(0, 7);
}

//カンマ区切り文字
export function parseComma(num: number): string {
  return String(num).replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1,')
}